const SESSION_KEY = "demoCatalogSessionId";

export const getSessionId = (): string => {
    const existing = sessionStorage.getItem(SESSION_KEY);
    if (existing && existing.trim()) {
        return existing;
    }

    const id = (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
        ? crypto.randomUUID()
        : `sess_${Math.random().toString(16).slice(2)}_${Date.now()}`);

    sessionStorage.setItem(SESSION_KEY, id);
    return id;
};

export const getSessionHeaders = (): Record<string, string> => {
    return {
        "X-Session-Id": getSessionId(),
    };
};